import { Fragment } from 'react';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './ne... Remove this comment to see the full error message
import NewFolderButton from './newFolder/NewFolderButton';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Co... Remove this comment to see the full error message
import ContentUsage from './ContentUsage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { assertPropsDefined } from '../../utils/PropValidationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IndexHeaderButtons = ({
  createButton,
  usage,
  usageLimitCounterUpgradeKey,
  contentType,
  location,
  saveFolder,
  showNewFolderButton = true,
  extraButtons = []
}) => {
  assertPropsDefined({
    createButton,
    contentType,
    location,
    saveFolder,
    showNewFolderButton
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [usage && /*#__PURE__*/_jsx(ContentUsage, {
      usage: usage,
      contentType: contentType,
      usageLimitCounterUpgradeKey: usageLimitCounterUpgradeKey
    }), showNewFolderButton && /*#__PURE__*/_jsx(NewFolderButton, {
      saveFolder: saveFolder,
      location: location
    }), extraButtons, createButton]
  });
};
export default IndexHeaderButtons;